"use client"

import React, { useState } from "react"
import { Outlet, Link, useLocation } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import {
    FiHome,
    FiUsers,
    FiBriefcase,
    FiKey,
    FiUserCheck,
    FiPackage,
    FiDollarSign,
    FiCheckSquare,
    FiMessageSquare,
    FiBell,
    FiSettings,
    FiUser,
    FiLogOut,
    FiMenu,
    FiX,
} from "react-icons/fi"
import "./Layout.css"

const Layout = () => {
    const { user, logout, hasPermission, isAdmin } = useAuth()
    const location = useLocation()
    const [sidebarOpen, setSidebarOpen] = useState(false)

    const getUserInitials = () => {
        if (!user) return "?"
        const firstInitial = user.first_name?.charAt(0) || ""
        const lastInitial = user.last_name?.charAt(0) || ""
        return (firstInitial + lastInitial).toUpperCase()
    }

    const menuItems = [
        { path: "/", icon: FiHome, label: "Dashboard", permission: null },
        { path: "/users", icon: FiUsers, label: "Personel Yönetimi", permission: 5, adminOnly: true },
        { path: "/departments", icon: FiBriefcase, label: "Departmanlar", permission: 4 },
        { path: "/permissions", icon: FiKey, label: "Yetkiler", permission: 5, adminOnly: true },
        { path: "/customers", icon: FiUserCheck, label: "Müşteriler", permission: 1 },
        { path: "/services", icon: FiPackage, label: "Hizmetler", permission: 6 },
        { path: "/finances", icon: FiDollarSign, label: "Gelir/Gider", permission: 2 },
        { path: "/tasks", icon: FiCheckSquare, label: "Görevler", permission: 8 },
        { path: "/communications", icon: FiMessageSquare, label: "İletişim Takibi", permission: 9 },
        { path: "/notifications", icon: FiBell, label: "Bildirimler", permission: null },
        { path: "/settings", icon: FiSettings, label: "Ayarlar", permission: 7, adminOnly: true },
    ]

    const filteredMenuItems = menuItems.filter((item) => {
        if (item.adminOnly && !isAdmin) return false
        if (item.permission && !hasPermission(item.permission)) return false
        return true
    })

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen)
    }

    return React.createElement(
        "div",
        { className: "layout" },
        React.createElement(
            "aside",
            { className: `sidebar ${sidebarOpen ? "open" : ""}` },
            React.createElement(
                "div",
                { className: "sidebar-header" },
                React.createElement("h2", null, "Vireliosoft"),
                React.createElement("button", { className: "close-sidebar", onClick: toggleSidebar }, React.createElement(FiX)),
            ),
            React.createElement(
                "nav",
                { className: "sidebar-nav" },
                filteredMenuItems.map((item) =>
                    React.createElement(
                        Link,
                        {
                            key: item.path,
                            to: item.path,
                            className: `nav-item ${location.pathname === item.path ? "active" : ""}`,
                            onClick: () => setSidebarOpen(false),
                        },
                        React.createElement(item.icon, { className: "nav-icon" }),
                        React.createElement("span", null, item.label),
                    ),
                ),
            ),
            React.createElement(
                "div",
                { className: "sidebar-footer" },
                React.createElement(
                    Link,
                    { to: "/profile", className: "nav-item", onClick: () => setSidebarOpen(false) },
                    React.createElement(FiUser, { className: "nav-icon" }),
                    React.createElement("span", null, "Profilim"),
                ),
                React.createElement(
                    "button",
                    { className: "nav-item logout-btn", onClick: logout },
                    React.createElement(FiLogOut, { className: "nav-icon" }),
                    React.createElement("span", null, "Çıkış Yap"),
                ),
            ),
        ),
        React.createElement(
            "div",
            { className: "main-content" },
            React.createElement(
                "header",
                { className: "header" },
                React.createElement(
                    "button",
                    { className: "menu-toggle", onClick: toggleSidebar },
                    React.createElement(FiMenu),
                ),
                React.createElement(
                    "div",
                    { className: "header-user" },
                    React.createElement("div", { className: "user-avatar" }, getUserInitials()),
                    React.createElement(
                        "div",
                        { className: "user-info" },
                        React.createElement("span", null, `${user?.first_name} ${user?.last_name}`),
                        React.createElement("span", { className: "user-role" }, user?.role === "admin" ? "Admin" : "Personel"),
                    ),
                ),
            ),
            React.createElement("main", { className: "content" }, React.createElement(Outlet)),
            React.createElement(
                "footer",
                { className: "footer" },
                React.createElement("p", null, `© ${new Date().getFullYear()} Vireliosoft. Tüm hakları saklıdır.`),
            ),
        ),
    )
}

export default Layout
